import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { BaseComponent } from '../BaseComponent';
import { selectPermissions } from '../../modules/Api/selectors';

const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class PermissionComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  hasPermission() {
    // console.log("User Permissions:", this.props.permissions);
    if (!this.props.permission) return true;

    const pArray = Array.isArray(this.props.permission) ? this.props.permission : [this.props.permission];
    let isAllowed = false;
    for (let item of pArray) {
      isAllowed = isAllowed ? isAllowed : this.props.permissions?.includes(item);
    }

    return isAllowed;
  }

  render() {
    return <>{this.hasPermission() ? this.props.children : this.props.proxy ?? null}</>;
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    permissions: selectPermissions(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {};
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const Permission = compose(withConnect, withRouter)(PermissionComp);
